import { Grid } from "@mui/material";
import { Emptyable } from "@simplyk/common";

import { useCurrentUserContext } from "../../../../../common/contexts/CurrentUserContext";

import { EmailPreviewBodyCard } from "./EmailPreviewBodyCard";
import { EmailPreviewSender } from "./EmailPreviewSender";
import { useFormattedEmailBody } from "./useFormattedEmailBody";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface EmailPreviewProps {
  body: string;
  emailContentId?: Emptyable<string>;
  recipientEmails: string[];
  subject: string;
  senderName: Emptyable<string>;
  htmlOnly?: boolean;
}

export const EmailPreview = ({ body, emailContentId, recipientEmails, subject, senderName }: EmailPreviewProps) => {
  const { organization, currentUser } = useCurrentUserContext();
  const bodyHtml = useFormattedEmailBody({ body, emailContentId, recipientEmails });

  return (
    <Grid
      container
      height="100%"
      direction="column"
      flexWrap="nowrap"
      sx={{ overflowY: "auto" }}
      paddingRight={{ xs: 0, md: 2 }}
    >
      <Grid item>
        <Grid container padding={2} paddingTop={0}>
          {subject && (
            <Grid xs={12} item marginBottom={1}>
              <DashboardTypography variant="subtitle1" vibe="text-neutral-moderate">
                {subject}
              </DashboardTypography>
            </Grid>
          )}
          <Grid item xs={12}>
            <EmailPreviewSender name={senderName || organization?.name} email={currentUser?.email} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs>
        <Grid
          container
          sx={(theme) => ({
            backgroundColor: theme.palette.surface.neutral.quiet,
            paddingTop: { xs: 2, md: 5 },
            paddingBottom: { xs: 2, md: 5 },
            paddingRight: { xs: 1, md: 0 },
            paddingLeft: { xs: 1, md: 0 },
            height: "100%",
            overflowY: "auto",
            display: "flex",
            justifyContent: "center",
            borderRadius: theme.radius(1),
          })}
        >
          <Grid item sx={{ maxWidth: 427 }}>
            <EmailPreviewBodyCard bodyHtml={bodyHtml} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
